var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHyperlinkProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.21 7.82043L12.51 12.2804C12.2 12.4604 11.81 12.4604 11.49 12.2804L3.78997 7.82043C3.23997 7.50043 3.09997 6.75043 3.51997 6.28043C3.80997 5.95043 4.13997 5.68043 4.48997 5.49043L9.90997 2.49043C11.07 1.84043 12.95 1.84043 14.11 2.49043L19.53 5.49043C19.88 5.68043 20.21 5.96043 20.5 6.28043C20.9 6.75043 20.76 7.50043 20.21 7.82043Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.43 14.1399V20.9599C11.43 21.7199 10.66 22.2199 9.97998 21.8899C7.91998 20.8799 4.44998 18.9899 4.44998 18.9899C3.22998 18.2999 2.22998 16.5599 2.22998 15.1299V9.96988C2.22998 9.17988 3.05998 8.67988 3.73998 9.06988L10.93 13.2399C11.23 13.4299 11.43 13.7699 11.43 14.1399Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5701 14.1399V20.9599C12.5701 21.7199 13.3401 22.2199 14.0201 21.8899C16.0801 20.8799 19.5501 18.9899 19.5501 18.9899C20.7701 18.2999 21.7701 16.5599 21.7701 15.1299V9.96988C21.7701 9.17988 20.9401 8.67988 20.2601 9.06988L13.0701 13.2399C12.7701 13.4299 12.5701 13.7699 12.5701 14.1399Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlinkProduct);
export default __webpack_public_path__ + "static/media/hyperlink-product.097cf0d0d179ce329eed87d32c2f42ba.svg";
export { ForwardRef as ReactComponent };